import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadExcel, clearMessages } from "../../../redux/productSlice";

const ExcelUpload = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.products);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    dispatch(clearMessages());
  };

  const handleUpload = () => {
    if (!file) return alert("Please select a file!");

    const formData = new FormData();
    formData.append("file", file);
    
    dispatch(uploadExcel(formData));
  };

  return (
    <div className="max-w-md p-6 mx-auto space-y-4 bg-white shadow-md rounded-xl">
      <h2 className="text-xl font-semibold">Upload Products via Excel</h2>
      <input
        type="file"
        accept=".xlsx"
        onChange={handleFileChange}
        className="block w-full text-sm text-gray-500"
      />
      <button
        onClick={handleUpload}
        disabled={loading}
        className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Uploading..." : "Upload"}
      </button>
      {success && <p className="text-green-600">{success}</p>}
      {error && <p className="text-red-600">{error}</p>}
    </div>
  );
};

export default ExcelUpload;
